import type { BackupDriver } from '../lib/types.js';

/** Other licensed drivers this driver trusts; the rider books them directly on their own page. */
export function Backups({ list, driverName, title }: { list: BackupDriver[]; driverName: string | null; title?: string }) {
  if (!list.length) return null;
  return (
    <section className="mt-4">
      <h2 className="mb-2 text-xs font-bold uppercase tracking-wide text-muted">{title ?? `Drivers ${driverName ?? 'this driver'} trusts`}</h2>
      <div className="space-y-2">
        {list.map((b) => (
          <a key={b.handle} href={`/${b.handle}`} className="flex items-center gap-3 rounded-2xl border border-line bg-card p-3">
            {b.photoUrl ? (
              <img src={b.photoUrl} alt="" className="h-12 w-12 shrink-0 rounded-xl object-cover" />
            ) : (
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-brand text-lg font-black text-on-brand">{(b.displayName ?? '?').slice(0, 1)}</div>
            )}
            <div className="min-w-0">
              <div className="truncate font-bold">{b.displayName}</div>
              {b.serviceArea && <div className="truncate text-xs text-muted">Serving {b.serviceArea}</div>}
            </div>
            <span className="ml-auto shrink-0 text-sm font-bold text-accent-text">See times ›</span>
          </a>
        ))}
      </div>
      <p className="mt-2 text-xs text-muted">Independent licensed drivers. You book and pay them directly on their own page.</p>
    </section>
  );
}
